"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.splitValues = void 0;

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@cimpress/react-components/lib/TextField"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _flow = _interopRequireDefault(require("lodash/fp/flow"));

var _map = _interopRequireDefault(require("lodash/fp/map"));

var _trim = _interopRequireDefault(require("lodash/fp/trim"));

var _reject = _interopRequireDefault(require("lodash/fp/reject"));

var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _keys = _interopRequireDefault(require("lodash/keys"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var splitValues = function splitValues(value, delimiters) {
  var splitRegex = new RegExp("[".concat(delimiters.join(''), "]"), 'i');
  var values = (value || '').split(splitRegex);
  return (0, _flow["default"])((0, _map["default"])(_trim["default"]), (0, _reject["default"])(_isEmpty["default"]))(values);
};

exports.splitValues = splitValues;
var ENTER_KEY = 13;
var COMPONENT_PROPS = {
  multiValueDelimiter: _propTypes["default"].arrayOf(_propTypes["default"].string),
  listDelimiter: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onEnterPressed: _propTypes["default"].func,
  enableEnterPressed: _propTypes["default"].bool,
  onMultipleValuesInputed: _propTypes["default"].func,
  onDelimitedListInputed: _propTypes["default"].func,
  splitValues: _propTypes["default"].func
};

var AdvancedTextField =
/*#__PURE__*/
function (_Component) {
  _inherits(AdvancedTextField, _Component);

  var _super = _createSuper(AdvancedTextField);

  function AdvancedTextField() {
    var _this;

    _classCallCheck(this, AdvancedTextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "keyDownHandler", function (event) {
      if (event.keyCode === ENTER_KEY && _this.props.enableEnterPressed) {
        _this.props.onEnterPressed();
      } else if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "pasteHandler", function (event) {
      var values = _this.props.splitValues(event.clipboardData.getData('text/plain'), _this.props.multiValueDelimiter);

      if (values.length > 1) {
        _this.props.onMultipleValuesInputed(values);

        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeHandler", function (sourceEvent) {
      if (_this.props.onChange) {
        var event = _objectSpread({}, sourceEvent);

        var values = _this.props.splitValues(event.target.value, _this.props.listDelimiter);

        if (values.length > 1) {
          _this.props.onDelimitedListInputed(true);

          event.target.values = values;
        } else {
          _this.props.onDelimitedListInputed(false);

          delete event.target.values;
        }

        _this.props.onChange(event);
      }
    });

    return _this;
  }

  _createClass(AdvancedTextField, [{
    key: "render",
    value: function render() {
      var passThroughProps = (0, _omit["default"])(this.props, ['onKeyDown', 'onChange'].concat(_toConsumableArray((0, _keys["default"])(COMPONENT_PROPS))));
      return (
        /*#__PURE__*/
        _react["default"].createElement(_TextField["default"], _extends({
          onKeyDown: this.keyDownHandler,
          onPaste: this.pasteHandler,
          onChange: this.changeHandler
        }, passThroughProps))
      );
    }
  }]);

  return AdvancedTextField;
}(_react.Component);

_defineProperty(AdvancedTextField, "propTypes", _objectSpread({}, COMPONENT_PROPS));

_defineProperty(AdvancedTextField, "defaultProps", _objectSpread(_objectSpread({}, _TextField["default"].defaultProps), {}, {
  onEnterPressed: function onEnterPressed() {},
  enableEnterPressed: true,
  onMultipleValuesInputed: function onMultipleValuesInputed() {},
  multiValueDelimiter: ['\r\n', '\t'],
  listDelimiter: [','],
  onDelimitedListInputed: function onDelimitedListInputed() {},
  splitValues: splitValues
}));

var _default = AdvancedTextField;
exports["default"] = _default;